import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser } from "../../actions/authActions";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import Footer from "../partials/Footer";
import * as myConstList from '../../BaseUrl';

class LogoutStorage extends Component {
  constructor(props) {
    super(props);
}

componentDidMount() { 
    this.props.logoutUser();
};

    onLogoutClick = e => {
        e.preventDefault();
        this.props.logoutUser();
    };    
    render() {
        //const { user } = this.props.auth;
        return (
            <>
                <Sidebar />
                    <Navbar urlPath={true} symbol={false}/>
                
                    <Footer />
</>
        );
    }
}

LogoutStorage.propTypes = {
    logoutUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth
});

export default connect(
    mapStateToProps,
    { logoutUser }
)(LogoutStorage);
